import { createElement } from 'react';

import { cn } from '@/lib/utils';
import { FIELD_TYPE_META } from '@/features/module-builder/constants';
import type { ModuleFieldType } from '@/features/module-builder/types';

export interface FieldTypeIconProps {
    fieldType: ModuleFieldType;
    className?: string;
}

/**
 * The field-type glyph (colored per FIELD_TYPE_META) shown next to field
 * labels across the quick view, record page, and form surfaces.
 */
export function FieldTypeIcon({ fieldType, className }: FieldTypeIconProps) {
    const meta = FIELD_TYPE_META[fieldType];
    if (!meta) return null;
    return createElement(meta.icon, {
        className: cn('size-3.5 shrink-0', className),
        style: { color: meta.color },
        'aria-hidden': true,
    });
}
